module.exports = __webpack_public_path__ + "static/sample_car_right_front.9dd4e84c.png";